import { Button, Col, Form, Nav, Navbar, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "react-toastify";

export default function CustomNavbar({
  loading,
  setLoading,
  setShowCreate,
  isPrivate,
}) {
  const { logout, currentUser } = useAuth();

  const navigation = useNavigate();

  const showToast = (message, type) => {
    const options = { type: type };
    toast(message, options);
  };

  async function logoutSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);
      await logout();
      showToast("Erfolgreich abgemeldet.", toast.TYPE.SUCCESS);
      setLoading(false);
    } catch (e) {
      console.log(e.message);
      showToast("Fehler beim Abmelden!", toast.TYPE.ERROR);
      setLoading(false);
    }
  }

  const NavbarButtons = () =>
    currentUser ? (
      <>
        {isPrivate ? (
          <Button
            style={{
              marginRight: "10px",
            }}
            variant="outline-dark"
            onClick={() => navigation("/")}
          >
            <Row>
              <Col className="d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                  />
                </svg>
              </Col>
              <Col className="d-none d-sm-block" style={{ paddingLeft: "0px" }}>
                <div style={{ whiteSpace: "nowrap" }}>Homepage</div>
              </Col>
            </Row>
          </Button>
        ) : (
          <Button
            style={{
              marginRight: "10px",
            }}
            variant="outline-dark"
            onClick={() => navigation("/my-items")}
          >
            <Row>
              <Col className="d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                  <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z" />
                </svg>
              </Col>
              <Col className="d-none d-sm-block" style={{ paddingLeft: "0px" }}>
                <div style={{ whiteSpace: "nowrap" }}>Meine Artikel</div>
              </Col>
            </Row>
          </Button>
        )}
        <Button
          style={{
            marginRight: "10px",
          }}
          variant="outline-success"
          onClick={() => setShowCreate(true)}
        >
          <Row>
            <Col className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
              </svg>
            </Col>
            <Col className="d-none d-sm-block" style={{ paddingLeft: "0px" }}>
              <div style={{ whiteSpace: "nowrap" }}>Artikel hochladen</div>
            </Col>
          </Row>
        </Button>

        <Form onSubmit={logoutSubmit} style={{ marginRight: "10px" }}>
          <Button disabled={loading} type="submit">
            Abmelden
          </Button>
        </Form>
      </>
    ) : (
      <>
        <Row style={{ margin: "0px" }}>
          <Col>
            <Nav.Link href="/login" style={{ color: "#0d6efd" }}>
              Anmelden
            </Nav.Link>
          </Col>
          <Col>
            <Nav.Link href="/sign-up" style={{ color: "#6c757d" }}>
              Registrieren
            </Nav.Link>
          </Col>
        </Row>
      </>
    );

  return (
    <Navbar
      bg="light"
      variant="light"
      className="mt-0 d-flex justify-content-between"
      sticky={
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
          ? ""
          : "top"
      }
      style={{
        padding: "0.5rem",
        maxWidth: "100%",
      }}
    >
      <Navbar.Brand href="/">
        <Row>
          <Col className="d-flex align-items-center">
            <img
              src={require("../assets/logo/logo512.png")}
              width="32"
              height="32"
              className="align-top"
              alt="ASV Logo"
              style={{ marginLeft: "10px", padding: "0px" }}
            />
          </Col>
          <Col
            className="d-none d-md-block"
            style={{ marginLeft: "10px", padding: "0px" }}
          >
            <div style={{ whiteSpace: "nowrap" }}>ASV Börse</div>
          </Col>
        </Row>
      </Navbar.Brand>
      <Nav style={{ maxWidth: "100%" }}>
        <NavbarButtons />
      </Nav>
    </Navbar>
  );
}
